import { gql } from '@apollo/client'

export const GET_TAGS = gql`
  query getTags($organisationID: ID!) {
    tags(organisationID: $organisationID) {
      id
      name
      color
    }
  }
`
